import { AppState } from '../../../redux/reducers';
import * as PractitionerConsumptionStore from '../../../redux/middleware/PractitionerConsumptionMiddleware';
import { PractitionerConsumption } from '../../../models/Entities/Practitioners/PractitionerConsumption';
import { Practitioner } from '../../../models/Entities/Practitioners/Practitioner';
import { RateTypeEnum } from '../../../models/Enums/RateTypeEnum';
import { normalizeRateToPrecision, RATE_MAX_DECIMALS } from '../../../commons/interfaces';

interface IProps {
  PractitionerId: string;
  ConsumptionId: string;
  isOpen: boolean;
  onClose: () => void;
}

interface ConnectedProps {
  Consumption: PractitionerConsumption | undefined;
  isSaving: boolean;
  error: string | undefined;
}

interface DispatchProps {
  ChangeRate: typeof PractitionerConsumptionStore.ActionCreators.ChangeRate;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, own: IProps): ConnectedProps => {
  const practitioner = state.Practitioners?.list?.find((p: Practitioner) => p.userId === own.PractitionerId);
  const consumption = practitioner?.consumptions?.find((c: PractitionerConsumption) => c.id === own.ConsumptionId);

  return {
    Consumption: consumption,
    isSaving: !!consumption?.isRateChanging,
    error: consumption?.ErrorOnRateChange,
  };
};

export const mapDispatchToProps = {
  ...PractitionerConsumptionStore.ActionCreators,
};

export const getRateTypeLabel = (value: number | undefined): string => {
  switch (value) {
    case RateTypeEnum.InvoiceDate:
      return 'Fecha de factura';
    case RateTypeEnum.PaymentDate:
      return 'Fecha de pago';
    case RateTypeEnum.Manual:
      return 'Manual';
    case RateTypeEnum.Automatic:
      return 'Automática';
    default:
      return '-';
  }
};

export const isValidRateInput = (input: string): boolean => {
  if (input.trim() === '') return false;
  const value = Number(input);
  if (!Number.isFinite(value) || value <= 0) return false;

  const decimals = input.includes('.') ? input.split('.')[1]?.length ?? 0 : 0;
  return decimals <= RATE_MAX_DECIMALS;
};

export const normalizeRateInput = (input: string): number | undefined => {
  if (!isValidRateInput(input)) return undefined;
  return normalizeRateToPrecision(Number(input));
};

export const canApplyExpandedScope = (consumption: PractitionerConsumption | undefined): boolean => {
  return !!consumption?.relatedSettlementId;
};
